import React from 'react';
import { useParams } from 'react-router-dom';
import AdminHeader from '../../components/headers/AdminHeader';
import InsuranceUploadContent from '../../components/InsuranceUploadContent';
import { useInsuranceUpload } from '../../hooks/useInsuranceUpload';
import '../../styles/Tabs.css';
import '../../styles/AgencyRegistration.css';
import '../../styles/InsuranceUpload.css';
import '../../styles/PopUp.css';

// 申請アップロードページコンポーネント（管理者向け）
// ※pages/agencyにも同様のコンポーネントがあるため、修正時は同時に確認すること
const InsuranceUpload = () => {
  const { agencyId } = useParams();
  
  // カスタムフックを使用して共通処理を取得
  const insuranceUploadProps = useInsuranceUpload(agencyId);

  return (
    <>
      <AdminHeader />
      <InsuranceUploadContent {...insuranceUploadProps} />
    </>
  );
};

export default InsuranceUpload;